import { CancelBtn } from 'components/Button/CancelBtn'
import { Input } from 'components/Input/Input'
import { Animation, Button, Flex, H2, ItemsGrid, TabFooter, ThinSeparator } from 'styling/GlobalStyles'
import { IProcessTemplateTab } from 'types/processTemplates'
import { ISelectValue } from 'constants/globalTypes'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Type27Options } from './processTemplateData'
import { Container, ContainerContent, ContainerHeader } from 'components/Containers/Containers'
import { TitleText } from 'styling/Typography'

export const ProcessTemplatesDataTab = ({ state, setState, handleSubmit, view }: IProcessTemplateTab) => {

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, id: number, type: string, index: number) => {
        const { value } = e.target
        setState(prev => {
            const copy = structuredClone(prev)

            copy.processFunction[type] = copy.processFunction[type].map(t => {
                if (t.component == id && t.index == index) {
                    t.componentGivenName = value
                }
                return t
            })

            return copy
        })
    }

    const handleSelect = (type: ISelectValue, id: number, displayInput?: boolean) => {
        setState(prev => {
            const copy = structuredClone(prev)
            if (displayInput) {
                const index = copy.processFunction.displayInputs.findIndex(d => d.component == id)
                copy.processFunction.displayInputs[index].value = type
            }
            return copy
        })
    }



    return state.processFunction ? <Animation>

        <Container>
            <ContainerHeader>
                <TitleText>Components</TitleText>
            </ContainerHeader>
            <ContainerContent>
                <Flex gap='1rem' column height='100%' >
                    <ItemsGrid columns={3} >
                        {state.processFunction?.inputs.map(i => <Input
                            key={i.component}
                            type='text'
                            value={i.componentGivenName}
                            onChange={e => handleChange(e, i.component, 'inputs', i.index)}
                            placeholder='Enter name'
                            labelText={i.name + ' Input name'}
                            invalid={i.componentGivenName?.length < 2 ? 'true' : ''}
                            nomarg
                            view={view}
                        />)}


                    </ItemsGrid>

                    <ThinSeparator />
                    <ItemsGrid columns={3} >
                        {state.processFunction?.outputs.map(o => <Input
                            key={o.component}
                            type='text'
                            value={o.componentGivenName}
                            onChange={e => handleChange(e, o.component, 'outputs', o.index)}
                            placeholder='Enter name'
                            labelText={o.name || '' + ' Output name'}
                            invalid={o.componentGivenName?.length < 2 ? 'true' : ''}
                            nomarg
                            view={view}
                        />)}
                    </ItemsGrid>
                    <ThinSeparator />
                    {state.processFunction?.displayInputs.map(d => <HonestSelectInput
                        labelText={d.name}
                        options={Type27Options}
                        key={d.component}
                        onChange={(type: ISelectValue) => handleSelect(type, d.component, true)}
                        defaultValue={d.value?.value}
                        menuTop={true}
                    />)}



                </Flex>
            </ContainerContent>
        </Container>


        {handleSubmit && (
            <TabFooter>
                <Flex width='100%' end='true'>
                    <CancelBtn />
                    <Button ml='15' height='40' onClick={handleSubmit} orange>
                        Save
                    </Button>
                </Flex>
            </TabFooter>
        )}
    </Animation> : <Animation><H2>Select function first to fill the data</H2></Animation>
}